import { z } from "zod"

export const choiceSchema = z.object({
  /** The name of the choice */
  name: z.string().optional(),
  /** The display name of the choice */
  displayName: z.string().optional(),
  /** The value of the choice */
  value: z.string(),
  displayValue: z.string().optional(),
  dataValue: z.string().optional(),
  likelihood: z.number().nullable().optional(),
})

export type Choice = z.infer<typeof choiceSchema>
